import React from 'react'
import CreditCard from './components/payment-types/CreditCard'
import BankAccount from './components/payment-types/BankAccount'

interface PaymentTypeSelectionProps {
  total?: number
}

const PaymentTypeSelection: React.FC<PaymentTypeSelectionProps> = ({ total = 1 }) => {
  if ( total === 0 ) return null


  return (
    <div className="flex flex-col w-full gap-3 max-w-2xl mx-auto px-2 mb-8">
      <div className="w-full p-3">
        <p className="sm:text-3xl md:text-[35px] font-semibold font-inter text-[#0057A8] text-center leading-10">
          {`Enter Your Payment Info`}
        </p>
      </div>
      <div className="pb-4 flex flex-col gap-4 w-full">
        <CreditCard />
        <BankAccount />
      </div>
    </div>
  )
}

export default PaymentTypeSelection